"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdiabasInterface = void 0;
class EdiabasInterface {
    connected = false;
    async transmitFrequent(data) {
        void data;
    }
    async receiveFrequent() {
        return new Uint8Array(0);
    }
    async stopFrequent() { }
    isConnected() {
        return this.connected;
    }
}
exports.EdiabasInterface = EdiabasInterface;
//# sourceMappingURL=EdiabasInterface.js.map